import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/ancillon.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LBr. 12, Bl. 85<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 12 December 1710<br /><br />
		Translated from the French<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (99k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Charles Ancillon (12 December 1710)</title>
            <meta name="description" content="An English translation of a letter from GOTTFRIED WILHELM LEIBNIZ TO CHARLES ANCILLON, from 12 December 1710" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO CHARLES ANCILLON</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>LBr. 12, Bl. 85</b>]<br /><br />		

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Extract from my letter to Mr Ancillon<br /><br />

                <div align="right">12 December 1710</div><br /><br />
                    
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;My <var>Essays</var> have indeed appeared,<a name="1" href="#note1"><sup>1</sup></a> although without my name. I still have no copy of the book here, aside from the one that was sent to me piecemeal as the printing was done. There are additions, Sir, that you have not seen yet. If this book is tolerable, I am to a large extent obliged to you, Sir, for that. Mr Bernard has begun to write a report on it in September's edition of the <var>Nouvelles de la republique des lettres</var>.<a name="2" href="#note2"><sup>2</sup></a> I am sorry that this little work did not appear when Mr Basnage de Beauval was still in a condition to speak of it.<a name="3" href="#note3"><sup>3</sup></a> I would have been glad to learn of his view too, but even more so that of Mr Bayle and Mr Jaquelot. Of all these combatants there remains only Mr Le Clerc, who has not yet spoken, as Mr Bernard has, but who will perhaps speak in his <var>Bibliotheque choisie</var>. I am in fact curious to know his thoughts. However, I am afraid that it may fall into the hands of an Archbishop of the Anglican Church, namely Mr King, who published some years ago a book entitled <var>De origine mali</var>.<a name="4" href="#note4"><sup>4</sup></a> He was at that time Bishop of Derry, and I thought he still was, but I understand that he is now Archbishop of Dublin. I found myself more or less compelled to discuss his book and his opinion, and although I am not always of his mind, I hope I have written in a way that will not offend him.<a name="5" href="#note5"><sup>5</sup></a> I do not know if he is a Whig or a Tory, but the sciences are not of any party. I hope that my book will not displease the moderates of Berlin, like, among others, Mr l'Enfant (from whom I do not expect a response since my letter was one) and even less Mr Strimesius and Mr Holzfus, very wise Reformed theologians at Frankfurt on the Oder; but it will not likewise satisfy the rigid gentlemen, like Mr Becman in Frankfurt (according to what is said) and Mr Naude in Berlin, and generally those who compare what God does to us with what we do to little earthworms. But I hope they will still approve of my moderation.
                        <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> That is, Leibniz's <var>Theodicy: Essays on the Goodness of God, the Freedom of Man and the Origin of Evil</var>. It was published late in 1710.<br />
                        <a name="note2" href="#2">2.</a> See the review in <var>Nouvelles de la Republique des lettres</var> (September 1710), 314-342.<br />
                        <a name="note3" href="#3">3.</a> Henri Basnage de Beauval (1657-1710), editor of the <var>Histoire des ouvrages des savants</var>, died on 29 May 1710.<br />
                <a name="note4" href="#4">4.</a> William King, <var>De origine mali</var> (London: Benjamin Tooke, 1704).<br />
                <a name="note5" href="#5">5.</a> Leibniz is referring to his essay, &quot;Observations on the book concerning 'The Origin of Evil' published recently in London,&quot; published as an appendix to the <var>Theodicy</var>.
                <br /><br /><br />
                        &#169; Lloyd Strickland 2014, 2018
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
